import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Separator } from "@/components/ui/separator";
import { Textarea } from "@/components/ui/textarea";
import { useEffect, useState } from 'react';
import { OrganizationSelect } from "@/components/OrganizationSelect";
import HttpPingConfig from "./Configurations/HttpPingConfig";
import BrowserAgentConfig from "./Configurations/BrowserAgentConfig";

const DEFAULT_REQUEST_HEADERS = `Content-Type: application/json
Authorization: Bearer YOUR_TOKEN`;

const DEFAULT_REQUEST_BODY = `{
  "key": "value",
  "anotherKey": 123,
  "nestedObject": {
    "nestedKey": "nestedValue"
  }
}`;

const ConfigurationStep = ({ stepKey, updateStepData, getStepData }) => {
    const stepData = getStepData(stepKey);
    const actionType = getStepData('actionType');
    const [showRequestHeaders, setShowRequestHeaders] = useState(stepData.requestHeaders ? true : false);
    const [showRequestBody, setShowRequestBody] = useState(stepData.requestBody ? true : false);

    useEffect(() => {
        if (Object.keys(stepData).length > 0) {
            updateStepData(stepKey, stepData);
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newData = { ...stepData, [name]: value };
        updateStepData(stepKey, newData);
    };

    const handleSelectChange = (field, value) => {
        const newData = { ...stepData, [field]: value };
        updateStepData(stepKey, newData);
    };

    const handleRequestHeadersChange = (e) => {
        const { value } = e.target;
        const newData = { ...stepData, requestHeaders: value };
        updateStepData(stepKey, newData);
    };

    const handleRequestBodyChange = (e) => {
        const { value } = e.target;
        const newData = { ...stepData, requestBody: value };
        updateStepData(stepKey, newData);
    };

    const toggleRequestHeaders = () => {
        setShowRequestHeaders(!showRequestHeaders);
        if (!showRequestHeaders && !stepData.requestHeaders) {
            updateStepData(stepKey, { ...stepData, requestHeaders: DEFAULT_REQUEST_HEADERS });
        } else if (showRequestHeaders) {
            updateStepData(stepKey, { ...stepData, requestHeaders: '' });
        }
    };

    const toggleRequestBody = () => {
        setShowRequestBody(!showRequestBody);
        if (!showRequestBody && !stepData.requestBody) {
            updateStepData(stepKey, { ...stepData, requestBody: DEFAULT_REQUEST_BODY });
        } else if (showRequestBody) {
            updateStepData(stepKey, { ...stepData, requestBody: '' });
        }
    };

    const handleOrganizationChange = (id, name) => {
        updateStepData(stepKey, {
            ...stepData,
            organizationId: id,
            organizationName: name
        });
    };

    const renderConfiguration = () => {
        switch (actionType) {
            case 'ping':
                return <HttpPingConfig stepKey={stepKey} updateStepData={updateStepData} getStepData={getStepData} />;
            case 'browser_agent':
                return <BrowserAgentConfig stepKey={stepKey} updateStepData={updateStepData} getStepData={getStepData} />;
            default:
                return null;
        }
    };

    return (
        <div className="flex flex-col space-y-8 items-center">
            <div className="flex flex-col items-center space-y-3">
                <h1 className="font-semibold text-3xl text-center">Configuration</h1>
                <p className="text-center text-muted-foreground">Customize your monitor settings</p>
            </div>
            <div className="w-full max-w-2xl mx-auto space-y-8">
                <div className="flex flex-col space-y-3">
                    <Label htmlFor="organizationId">Organization</Label>
                    <OrganizationSelect
                        preselect
                        value={stepData.organizationId}
                        onChange={handleOrganizationChange}
                    />
                    <p className="text-xs text-muted-foreground">
                        Everyone in the organization will be able to view this monitor
                    </p>
                </div>
                <Separator />
                {renderConfiguration()}
            </div>
        </div>
    );
};

export default ConfigurationStep;
